import InteresForm from './InteresForm'
export {InteresForm}
export default InteresForm
